import { Injectable, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { DialogService } from '../core/dialog-service';
import { Observable, throwError } from 'rxjs';
import { IToken } from '../../models/account/account-models';
import { SecuritySettingsModel } from '../../models/security/security-settings.model';

@Injectable({
    providedIn: 'root'  // <--provides this service in the root ModuleInjector
})
export class ApiService {
    private hasError: boolean = false;
    private baseUrl: string;
    constructor(private httpClient: HttpClient, private route: ActivatedRoute, private dialogService: DialogService
        , @Inject('BASE_URL') baseUrl: string, private router: Router) {
        this.baseUrl = baseUrl;
    }
    showSpinner(showSpinner?: boolean) {
        if (showSpinner && showSpinner === true)
            this.dialogService.showSpinner();
    }
    hideSpinner(showSpinner?: boolean) {
        if (showSpinner && showSpinner === true)
            this.dialogService.hideSpinner();
    }
    get<T>(url: string, showSpinner?: boolean, params?: { [name: string]: any; }, authorize?: boolean/*, noRedirectToLogin?: boolean*//*, options?: RequestOptionsArgs*/): Observable<T> {
        url = this.processUrl(url, params);        
        this.showSpinner(showSpinner);
        return this.httpClient.get<T>(url,).pipe(
            tap(() => this.hideSpinner(showSpinner)),
            catchError(error => this.handleError(error, this/*, noRedirectToLogin*/))
        );
    }
    getText<T>(url: string, showSpinner?: boolean, params?: { [name: string]: any; }, authorize?: boolean/*, options?: RequestOptionsArgs*/): Observable<string> {
        url = this.processUrl(url, params);
        this.showSpinner(showSpinner);
        return this.httpClient.get(url, { responseType: 'text' }).pipe(
            tap(() => this.hideSpinner(showSpinner)),
            catchError(error => this.handleError(error, this))
        );
    }
    postText<TOut>(url: string, body: string, showSpinner?: boolean, authorize?: boolean): Observable<TOut> {
        url = this.resolveUrl(url);
        this.showSpinner(showSpinner);
        return this.httpClient.post<TOut>(url, '"' + body + '"', { headers: new HttpHeaders({ 'Content-Type': 'application/json' })}).pipe(
            tap(() => this.hideSpinner(showSpinner)),
            catchError(error => this.handleError(error, this))
        );
    }
    post<TIn, TOut>(url: string, body: TIn, showSpinner?: boolean, authorize?: boolean/*, options?: RequestOptionsArgs*/): Observable<TOut> {
        url = this.resolveUrl(url);
        this.showSpinner(showSpinner);
        return this.httpClient.post<TOut>(url, body).pipe(
            tap(() => this.hideSpinner(showSpinner)),
            catchError(error => this.handleError(error, this))
        );
    }
    /*postWithTextResponse<TIn>(url: string, body: string, showSpinner?: boolean, authorize?: boolean): Observable<string> {
        url = this.resolveUrl(url);
        this.showSpinner(showSpinner);
        return this.httpClient.post<string>(url, body
            , {
                headers: new HttpHeaders({
                    'Content-Type': 'text/plain',//unsupported media type ?
                })
            //, { Headers, responseType: 'text' as 'json' }
            ) 
            .pipe(
                tap(() => this.hideSpinner(showSpinner)),
                catchError(error => this.handleError(error, this))
            );
    }*/
    public put<T>(url: string, data: any, showSpinner?: boolean, authorize?: boolean/*, options?: RequestOptionsArgs*/): Observable<T> {
        url = this.resolveUrl(url);
        this.showSpinner(showSpinner);
        return this.httpClient.put<T>(url, data).pipe(
            tap(() => this.hideSpinner(showSpinner)),
            catchError(error => this.handleError(error, this))
        );
    }

    public delete<T>(url: string, showSpinner?: boolean, authorize?: boolean/*, options?: RequestOptionsArgs*/): Observable<T> {
        url = this.resolveUrl(url);
        this.showSpinner(showSpinner);
        return this.httpClient.delete<T>(url).pipe(
            tap(() => this.hideSpinner(showSpinner)),
            catchError(error => this.handleError(error, this))
        );
    }

    /*handleErrorOld(error: Response) {
        if (error.status === 401) {
            this.dialogService.hideSpinner();
            //this.$rootScope.$broadcast(this.appConfig.user_logged_in, { "user_logged_in": false });
            this.router.navigate(['/account/login']);
        }

        this.dialogService.hideSpinner();
        this.hasError = true;
        let msg = `Status Code ${error.status} on url ${error.url}`;
        console.error(msg);
        return Observable.throw(error);
    }*/

    /*private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // from angular.io
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }*/
    public handleError(error: HttpErrorResponse, apiService: ApiService/*, noRedirectToLogin?: boolean*/) {
        if (/*!noRedirectToLogin && */error.status === 401) {
            apiService.hideSpinner();
            //this.$rootScope.$broadcast(this.appConfig.user_logged_in, { "user_logged_in": false });
            if (this.route.snapshot.children && this.route.snapshot.children.length > 0 && this.route.snapshot.children[0].url.length > 0 && this.route.snapshot.children[0].url[0].path == 'home')
                return throwError(error || 'Node.js server error');
            if (this.route.snapshot.children && this.route.snapshot.children.length > 0 && this.route.snapshot.children[0].url.length > 1 &&
                this.route.snapshot.children[0].url[0].path == 'account' && this.route.snapshot.children[0].url[1].path == 'reset-password')
                return throwError(error || 'Node.js server error');
            if (!error.url.includes('account/GetCurrentUser'))//prevent GetCurrentUser redirecting on public pages
                this.router.navigate(['/account/login']);
        }
        apiService.hideSpinner(true);
        apiService.hasError = true;
        let msg = `Status Code ${error.status} on url ${error.url}`;
        if (error.error instanceof Error) {
            let errMessage = error.error.message;
            return throwError(errMessage);
            // Use the following instead if using lite-server
            //return Observable.throw(err.text() || 'backend server error');
        }
        if (error.error && error.error.errors && error.error.errors.Error) {
            if (error.error.errors.Error.indexOf('Data may have been modified or deleted') >= 0)
                alert('Another user has changed Information.  Please Refresh to view modifications made.');
            else
                alert(error.error.errors.Error);
        }
        else if (error.error && error.error.errors && error.error.errors.Message)
            alert(error.error.errors.Message);
        else if (error.error && typeof error.error == 'string' && error.error.length > 3)
            alert(error.error);
        return throwError(error || 'Node.js server error');
    }
    private processUrl(url: string, params?: { [name: string]: any; }) {
        url = this.resolveUrl(url);
        if (params && params !== null) {
            let esc = encodeURIComponent;

            let query = Object.keys(params)
                .map(k => esc(k) + '=' + esc(params[k]))
                .join('&');

            if (url.indexOf("&") < 0)
                url = url.indexOf("?") > -1 ? `${url}&${query}` : `${url}?${query}`;
            else
                url = `${url}&${query}`;
        }
        return url;
    }
    private resolveUrl(url: string): string {
        // If starts with http then ignore - if cross sites (e.g. Reporting)
        if (url.includes('http'))
        {
            return url;
        }
        else {
            return `${this.baseUrl}${url}`;
        }
    }
    getAuthorizationBearerString() {
        let tokenData = localStorage.getItem(SecuritySettingsModel.access_token);
        if (tokenData !== null) {
            let tokenJson = JSON.parse(tokenData) as IToken;
            let token: any = tokenJson.token;
            return `bearer ${token}`;
        }
        else {
            return ''
        };
    }
}